function isAndroid(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('android') > -1;
}

export default isAndroid;
